export default "/_next/static/videos/c2eee66ca085540cc7ec7a47a11caa11.mp4";